export const BANNER_BUSINESS_CORR_ID_LS_KEY: string = "cgp_orbitBusinessCorrelationIdFromBanner";